Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSharedValue = useSharedValue;
var _react = require("react");
var _animation = require("../animation");
var _core = require("../core");
function useSharedValue(init) {
    var oneWayReadsOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var ref = (0, _react.useRef)((0, _core.makeMutable)(init, oneWayReadsOnly));
    if (ref.current === null) {
        ref.current = (0, _core.makeMutable)(init, oneWayReadsOnly);
    }
    (0, _react.useEffect)(function() {
        return function() {
            (0, _animation.cancelAnimation)(ref.current);
        };
    }, []);
    return ref.current;
}
